import React, { useState } from "react";
import { useDispatch } from "react-redux";
import MaterialModal from "../MaterialModal";

import { hideModal } from "../../../actions/actionCreators";
import { List, ListItem, ListItemText, Button } from "@material-ui/core";

import withModal from "../withModal";
import { fetchT, IRequestResult, jsonHeaders } from "../../../helpers/typedFetch";
import { notifyGreen } from "../../../actions/notifyActions";
import h from "../../../helpers";

import { history } from "../../../store";

export type RefreshDeploymentModalProps = {
    flowId: number;
    flowName: string;
    flowItemId?: number;
    flowItemName?: string;
    destinationName?: string;
    flowUrl?: string;
};

type IProps = {
    isOpen: boolean;
    modalProps: RefreshDeploymentModalProps;
};
const RefreshDeployModal: React.FC<IProps> = ({ isOpen, modalProps }: IProps) => {
    const dispatch = useDispatch();
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleClose = () => {
        setErrorMessage("");
        dispatch(hideModal("DEPLOYMENT_REFRESH"));
    };

    const requestDeploymentRefresh = (unlockAndEdit: boolean) => {
        const url = "/flows/UnlockAndRefreshDeployment";

        setRequestInProgress(true);
        fetchT<IRequestResult>(
            url,
            "POST",
            JSON.stringify({ flowId: modalProps.flowId, flowItemId: modalProps.flowItemId, unlockAndEdit }),
            jsonHeaders
        )
            .then(data => {
                if (data.success) {
                    dispatch(notifyGreen("Deployment refresh was successfully submitted."));
                    handleClose();
                    if (unlockAndEdit) {
                        history.push(modalProps.flowUrl);
                    }
                } else if (data.message) {
                    setErrorMessage(data.message);
                } else {
                    h.error("There was an error requesting the deployment refresh.");
                }
                setRequestInProgress(false);
            })
            .catch(error => {
                h.error("There was an error requesting the deployment refresh.", error);
            });
    };

    const renderPreview = () => (
        <div className="listForModal">
            <List dense={true}>
                <ListItem>
                    <ListItemText primary="Flow: " secondary={modalProps.flowName} />
                </ListItem>
                {modalProps.flowItemName && (
                    <ListItem>
                        <ListItemText primary="Item: " secondary={modalProps.flowItemName} />
                    </ListItem>
                )}
                {modalProps.destinationName && (
                    <ListItem>
                        <ListItemText primary="Destination: " secondary={modalProps.destinationName} />
                    </ListItem>
                )}
                {errorMessage != "" && (
                    <ListItem className="redListItem">
                        <ListItemText
                            primary="Error: "
                            secondary={errorMessage}
                            secondaryTypographyProps={{
                                color: "error",
                            }}
                        />
                    </ListItem>
                )}
            </List>
        </div>
    );

    if (!modalProps) {
        return null;
    }

    const renderFooter = () => {
        const cancelBtn = (
            <Button
                id="material-modal-cancel-button"
                onClick={handleClose}
                color="primary"
                className="material-modal-cancel-btn"
                disabled={requestInProgress}
            >
                Cancel
            </Button>
        );
        const unlockAndEditBtn = (
            <Button
                id="material-modal-edit-button"
                variant="contained"
                color="secondary"
                className="material-modal-primary-btn"
                onClick={() => requestDeploymentRefresh(true)}
                disabled={requestInProgress}
            >
                Unlock and Edit
            </Button>
        );

        const unlockAndDeployBtn = (
            <Button
                variant="contained"
                color="primary"
                className="material-modal-primary-btn"
                onClick={() => requestDeploymentRefresh(false)}
                disabled={requestInProgress || errorMessage != ""}
            >
                Refresh and Deploy
            </Button>
        );

        return (
            <>
                {cancelBtn}
                {unlockAndEditBtn}
                {unlockAndDeployBtn}
            </>
        );
    };

    return (
        <MaterialModal
            id={"tapad-refresh-deploy-modal"}
            isOpen={isOpen}
            title={"Refresh"}
            footer={renderFooter()}
            onClose={handleClose}
        >
            {renderPreview()}
        </MaterialModal>
    );
};
export default withModal(RefreshDeployModal, "DEPLOYMENT_REFRESH");
